import { BASE_URL } from '@/constants'
import { useEffect, useState } from 'react'

interface PostLike {
  likes: number
  success: boolean
}

async function addLike(postId: number) {
  await fetch(`${BASE_URL}/wp-json/vhl/v1/post/like`, {
    method: 'POST',
    body: JSON.stringify({ post_id: postId }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

async function getLike(postId: number) {
  const data: PostLike = await fetch(
    `${BASE_URL}/wp-json/vhl/v1/post/get_like?post_id=${postId}`
  ).then(res => res.json())
  return data
}

function checkUserLiked(postId: number): boolean {
  if (!window.localStorage) return false
  const likedPosts: Array<number> = JSON.parse(
    window.localStorage.getItem('likedPosts') || '[]'
  )
  return likedPosts.includes(postId)
}

function addUserLiked(postId: number) {
  if (!window.localStorage) return
  const likedPosts: Array<number> = JSON.parse(
    window.localStorage.getItem('likedPosts') || '[]'
  )
  // if postId is already liked, return
  if (likedPosts.includes(postId)) return
  likedPosts.push(postId)
  window.localStorage.setItem('likedPosts', JSON.stringify(likedPosts))
}

export function useLike(postId: number) {
  const [likes, setLikes] = useState(0)
  const [isUserLiked, setIsUserLiked] = useState(false)
  // fetch number of likes at first
  useEffect(() => {
    getLike(postId).then(res => {
      setLikes(res.likes)
    })
    setIsUserLiked(checkUserLiked(postId))
  }, [])

  async function handleLike() {
    addLike(postId)
    setLikes(likes + 1)
    setIsUserLiked(true)
    addUserLiked(postId)
  }
  return { likes, isUserLiked, handleLike }
}
